module.exports = __webpack_public_path__ + "img/irritant.6cb89d67.svg";